export const Hero = () => {
  return (
    <section
      className="py-20 md:py-28 px-6 bg-slate-900 text-white relative overflow-hidden"
      data-testid="hero-section"
    >
      <div
        className="absolute inset-0 opacity-20 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle at 70% 30%, #059669, transparent 50%), radial-gradient(circle at 20% 70%, #0284c7, transparent 50%)",
        }}
      ></div>

      <div className="max-w-6xl mx-auto relative z-10 space-y-8">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-950/80 border border-emerald-500/40 text-emerald-400 text-xs font-semibold kaje-mono uppercase tracking-wider">
          <span>Proprietary Software Engineering</span>
        </div>

        <h1 className="text-4xl sm:text-6xl md:text-7xl font-bold tracking-tight text-white leading-[0.96]">
          <span className="kaje-ln">
            <span>Innovative Mobile Apps</span>
          </span>
          <span className="kaje-ln">
            <span>&amp; AI-Driven Digital</span>
          </span>
          <span className="kaje-ln">
            <span className="text-emerald-400">Products Delivered.</span>
          </span>
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end pt-4">
          <div className="lg:col-span-7 space-y-6">
            <p
              className="kaje-body text-lg md:text-xl text-slate-300 max-w-xl leading-relaxed kaje-fade-in"
              data-testid="hero-differentiator"
            >
              Direct access to the developer with no middlemen. Custom mobile applications
              featuring AI-powered technology, interactive experiences, and robust subscription
              architecture.
            </p>

            <div className="flex flex-wrap items-center gap-4 kaje-fade-in kaje-body">
              <a
                href="#contact"
                className="px-7 py-3.5 bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-bold text-xs uppercase tracking-wider rounded transition-colors shadow-lg"
                data-testid="hero-cta-contact"
              >
                Submit Project Requirements &rarr;
              </a>
              <a
                href="#verification"
                className="px-6 py-3.5 border border-slate-700 hover:border-slate-500 text-slate-200 font-semibold text-xs uppercase tracking-wider rounded transition-colors"
                data-testid="hero-cta-verification"
              >
                Business Registry Info
              </a>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="w-full aspect-[16/10] rounded-lg border border-slate-700 shadow-2xl overflow-hidden relative bg-slate-950">
              <img
                src="https://images.unsplash.com/photo-1551650975-87deedd944c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxtb2JpbGUlMjBhcHAlMjBwcm90b3R5cGUlMjBpbnRlcmZhY2UlMjBjaGFydHN8ZW58MHx8fHwxNzkyMzExNzMwfDA&ixlib=rb-4.1.0&q=85"
                alt="Mobile app prototype interface with AI interactive charts"
                className="absolute inset-0 w-full h-full object-cover kaje-drift"
                data-testid="hero-image"
              />
              <div className="absolute bottom-0 inset-x-0 p-4 bg-slate-950/80 text-xs kaje-body text-slate-300">
                <span className="font-bold text-emerald-400 kaje-mono">PROD-ENV //</span> Sole
                Trader Principal Delivery
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
